import {render} from 'preact';
import {render as renderReact} from 'preact/compat';
import $ from '@modules/jquery-import';
import {MediumDevice} from '@ultradent/components';
import MiniCart from '@containers/MiniCart';
import MiniCartBadge from '@containers/MiniCartBadge';
import MiniCartSummary from '@containers/MiniCartSummary';
import User from '@modules/User';
import UpiContextProvider from '@providers/UpiContextProvider';
import dataLayer from '@upi/data-layer';

const App = {
    init ( isEnabled = false ) {

        this.isLogged = User.isLogged();
        this.isEnabled = isEnabled;
        this.docEl = $( 'html' );

        this.toggleCartView = this.toggleCartView.bind( this );

        if ( this.isEnabled ) {
            $( document ).on( 'click', '[data-action="toggle-cart"]', this.toggleCartView );

            this.createCart();
        }
        const cartNav = document.getElementById( 'nav-item--cart' );
        if ( cartNav ) {
            this.createNavigation( cartNav );
        }

        const cartBadgeMobile = document.getElementById( 'nav-bar-cart-badge--mobile' );
        if ( cartBadgeMobile ) {
            this.createBadge( cartBadgeMobile );
        }
    },

    toggleCartView ( e ) {
        e.preventDefault();

        this.docEl.toggleClass( 'js-off-canvas--open' );

        if ( this.docEl.hasClass( 'js-off-canvas--open' ) ) {
            dataLayer.pageView.cart();
        }
    },

    createCart () {
        const contentSpacer = document.createElement( 'div' );
        contentSpacer.classList.add( 'off-canvas-panel--cart-spacer' );

        const rootEl = document.getElementById( 'cart-panel' );
        if ( rootEl ) {
            rootEl.classList.add( 'off-canvas-panel' );
            rootEl.classList.add( 'off-canvas-panel--cart' );
            rootEl.insertAdjacentElement( 'afterend', contentSpacer );

            render(
                <MediumDevice
                    className="h-full"
                    component="div">
                    <UpiContextProvider>
                        <MiniCart/>
                    </UpiContextProvider>
                </MediumDevice>,
                rootEl );
        }
    },

    createNavigation ( target ) {
        renderReact(
            <UpiContextProvider miniCartEnabled={this.isEnabled}>
                <MiniCartSummary/>
            </UpiContextProvider>,
            target )
    },

    createBadge ( target ) {
        renderReact(
            <UpiContextProvider>
                <MiniCartBadge/>
            </UpiContextProvider>,
            target )
    }
};


export default App;
